import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";

export function useDebugProblemCount(enabled: boolean) {
  const { appId, envId } = useEnvironment();
  return useQuery({
    queryKey: ["debug-problem-count", appId, envId],
    queryFn: async () => {
      const response =
        await api.get<"/apps/:appId/debug-events/problems/count">(
          `/apps/${appId}/debug-events/problems/count`,
          { params: { envId } },
        );
      return response.data.count;
    },
    enabled,
    refetchInterval: 30_000,
  });
}
